<template>
  <div class="app-wrapper">
    <navbar v-if="$route.path !== '/login' && this.$route.path !== '/'"></navbar>
    <router-view/>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue';

export default {
  components: {
    Navbar,
  },
};
</script>

<style lang="scss">
html {
  font-size: 16px;
}

.app-wrapper {
  font-family: 'GlacialIndifferenceRegular';
  font-weight: normal;
  font-style: normal;
}
</style>
